@use '../../../../styles/abstract/variables/breakpoints' as *;

:host {
    width: 100%;
    // background-color: rgb(255, 255, 255);
    padding: var(--m3-space-2) var(--m3-space-1) !important;
    align-items: center;
    // display: flex;
    display: grid;
    grid-template-columns: auto auto 1fr;


    * {
        box-sizing: border-box;
    }

    >:first-child:not(.start) {
        margin-left: 12px;
    }

    .start {
        grid-column: 1;
        display: flex;

        .leading-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 48px;
            height: 48px;

            &::before {
                content: '';
                display: block;
                width: 24px;
                height: 24px;
            }
        }
    }

    .end {
        grid-column: 3;
        display: flex;
        overflow: hidden;

        .ico {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 48px;
            height: 48px;

            &::before {
                content: '';
                display: block;
                width: 24px;
                height: 24px;
            }
        }
    }

    @include respond-up("expanded") {
        grid-template-columns: 1fr auto 1fr;
        justify-content: space-between;

        >:first-child:not(.start) {
            margin-left: 0;
        }

        .end {
            justify-content: flex-end;
        }
    }

    @include respond-up("large") {}
}

.title-container {
    grid-column: 2;
    display: flex;
    align-items: start;
    flex-direction: column;
    margin-right: 4px;
    margin-left: 4px;

    .main-title {
        font-size: var(--font-size-ma-4);
        color: var(--color-text1);
    }

    .subtitle {
        font-family: 'Lato-Bold';
        font-size: var(--font-size-mi-4);
        color: var(--color-text-head-secondary);
        white-space: nowrap;
        text-align: start;
    }

    @include respond-up("expanded") {
        flex-direction: row;
        width: fit-content;

        .main-title,
        .subtitle {
            font-family: 'Lato';
            font-size: var(--font-size-ma-4);
            color: var(--color-text1);
        }

        .subtitle {

            &::before {
                content: ' - ';
            }
        }
    }
}